import { render, staticRenderFns } from "./u8_content_dialog.vue?vue&type=template&id=c1f5ecfa"
import script from "./u8_content_dialog.vue?vue&type=script&lang=js"
export * from "./u8_content_dialog.vue?vue&type=script&lang=js"
import style0 from "./u8_content_dialog.vue?vue&type=style&index=0&id=c1f5ecfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports